import * as React from 'react';
import { flow } from 'lodash';
import Login from './scenes/Login';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { IStore } from '../../redux/IStore';
import SetPassword from './scenes/SetPassword';
import PolicyDetail from './scenes/PolicyDetail';
import ResetPassword from './scenes/ResetPassword';
import AccountSummary from './scenes/AccountSummary';
import CreateAnAccount from './scenes/CreateAnAccount';
import { Redirect, Route, Switch } from 'react-router';
import { IAuthState } from '../../services/auth/models';
import ForgottenPassword from './scenes/ForgottenPassword';
import { actions as authActions, IAuthActions } from '../../services/auth/reducer';

interface ICustomerAreaProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push(route: string);
  };
}

class CustomerArea extends React.Component<ICustomerAreaProps> {
  public componentWillMount() {
    if (process.env.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  private renderAuthenticatedRoutes = () => {
    return (
      <Switch>
        <Redirect from="/auth" to="/account/summary" />
        <Route exact={true} path="/account/summary" component={AccountSummary} />
        <Route exact={true} path="/account/quotes/:id" component={PolicyDetail} />
        <Route exact={true} path="/account/policies/:id" component={PolicyDetail} />
      </Switch>
    );
  }

  private renderUnauthenticatedRoutes = () => {
    return (
      <Switch>
        <Redirect from="/account" to="/auth/login" />
        <Route exact={true} path="/auth/login" component={Login} />
        <Route exact={true} path="/auth/remind" component={ForgottenPassword} />
        <Route exact={true} path="/password/set/:token" component={SetPassword} />
        <Route exact={true} path="/password/reset/:token" component={ResetPassword} />
        <Route exact={true} path="/auth/create-an-account" component={CreateAnAccount} />
      </Switch>
    );
  }

  public render() {
    const { auth } = this.props;

    return (
      <div className="internal-page">
        <div className="container">
          <Row>
            <Col md={12}>
              <div className="customer-area-container">
                {auth.isAuthenticated ? this.renderAuthenticatedRoutes() : this.renderUnauthenticatedRoutes()}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({...authActions}, dispatch),
      },
    }),
  ),
])(CustomerArea);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/index.tsx